{
  "pt": {
    "datatable": {
      "actions": {
        "bulk_action": "Ação em massa",
        "bulk_edit": "Editar em massa",
        "clear_filters": "Limpar filtros",
        "deselect_all": "Desmarcar tudo",
        "select_all": "Selecionar tudo"
      },
      "labels": {
        "gridlines": "Linhas de grade",
        "size": "Tamanho",
        "toggle_columns": "Alternar colunas"
      }
    }
  }
}
